import { FormControl, FormGroup } from '@angular/forms';
import { Place } from '../../../gk-dynamic-form/services/place/place.model';
import { GkPostalCode } from '../../../gk-dynamic-form/services/postal-code/postal-code.model';
import { Street } from '../../../gk-dynamic-form/services/street/street.model';
import { LawPersonType } from '../law-person/law-person.model';

export enum LawPersonControlName {
  Type = 'type',
  LegalPersonData = 'legalPersonData',
  NaturalPersonData = 'naturalPersonData',
  Address = 'address',
  ApplicantFromRegonAddress = 'applicantFromRegonAddress',
  AddressSelect = 'addressSelect',
}

export enum LegalPersonControlName {
  Name = 'name',
  Nip = 'nip',
  Regon = 'regon',
  TypeId = 'typeId',
  KrsNumber = 'krsNumber',
}

export enum NaturalPersonControlName {
  FirstName = 'firstName',
  LastName = 'lastName',
  Pesel = 'pesel',
  PermissionNumber = 'permissionNumber',
  PhoneNumber = 'phoneNumber',
  Email = 'email',
}

export enum LawPersonAddressControlName {
  Place = 'place',
  Street = 'street',
  StreetAbsence = 'streetAbsence',
  BuildingNumber = 'buildingNumber',
  LocalNumber = 'localNumber',
  PostalCode = 'postalCode',
  PostOffice = 'postOffice',
}

export enum MaxLengthAddressField {
  Place = 105,
  Street = 200,
  BuildingNumber = 50,
  LocalNumber = 15,
  PostalCode = 20,
}

export interface LawPersonFormGroup {
  [LawPersonControlName.Type]: FormControl<LawPersonType>;
  [LawPersonControlName.LegalPersonData]: FormGroup<LegalPersonFormGroup>;
  [LawPersonControlName.NaturalPersonData]: FormGroup<NaturalPersonFormGroup>;
  [LawPersonControlName.Address]: FormGroup<LawPersonAddressFormGroup>;
  [LawPersonControlName.ApplicantFromRegonAddress]: FormControl<boolean>;
}

export interface LegalPersonFormGroup {
  [LegalPersonControlName.Name]: FormControl<string>;
  [LegalPersonControlName.Nip]: FormControl<string>;
  [LegalPersonControlName.Regon]: FormControl<string>;
  [LegalPersonControlName.TypeId]: FormControl<string | number>;
  [LegalPersonControlName.KrsNumber]: FormControl<string>;
}

export interface NaturalPersonFormGroup {
  [NaturalPersonControlName.FirstName]: FormControl<string>;
  [NaturalPersonControlName.LastName]: FormControl<string>;
  [NaturalPersonControlName.Pesel]: FormControl<string>;
  [NaturalPersonControlName.PermissionNumber]: FormControl<string>;
  [NaturalPersonControlName.PhoneNumber]: FormControl<string>;
  [NaturalPersonControlName.Email]: FormControl<string>;
}

export interface LawPersonAddressFormGroup {
  [LawPersonAddressControlName.Place]: FormControl<Place>;
  [LawPersonAddressControlName.Street]: FormControl<Street>;
  [LawPersonAddressControlName.StreetAbsence]: FormControl<boolean>;
  [LawPersonAddressControlName.BuildingNumber]: FormControl<string>;
  [LawPersonAddressControlName.LocalNumber]: FormControl<string>;
  [LawPersonAddressControlName.PostalCode]: FormControl<GkPostalCode>;
  [LawPersonAddressControlName.PostOffice]: FormControl<string>;
}
